import { GenIcon } from '../helpers/IconBase.es.js';

const NavigationOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 17", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_18574)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M9.32467 5.04954C9.29867 5.05687 4.506 6.95887 4.506 6.95887C4.14966 7.09785 3.84548 7.34443 3.63578 7.6643C3.42607 7.98418 3.32127 8.36146 3.33593 8.74366C3.3506 9.12587 3.48401 9.49401 3.71761 9.79687C3.95121 10.0997 4.27339 10.3223 4.63934 10.4335L6.20334 10.8249L6.71867 12.5075C6.85578 12.8439 7.09007 13.1316 7.39158 13.3341C7.6931 13.5366 8.04815 13.6446 8.41134 13.6442H8.44067C8.80937 13.6395 9.16799 13.5232 9.4693 13.3106C9.77061 13.0981 10.0005 12.7993 10.1287 12.4535C10.1287 12.4535 11.924 7.67687 11.9287 7.65354C12.0232 7.29311 12.0217 6.91421 11.9243 6.55455C11.8269 6.19489 11.637 5.86702 11.3735 5.60357C11.1099 5.34012 10.782 5.15029 10.4223 5.05297C10.0626 4.95565 9.68374 4.95424 9.32334 5.04887L9.32467 5.04954ZM10.6467 7.28887L8.88134 11.9842C8.84735 12.0795 8.78482 12.162 8.70227 12.2204C8.61972 12.2789 8.52115 12.3105 8.42 12.3109C8.35334 12.3029 8.07 12.2935 7.97 12.0589L7.36467 10.0749C7.33122 9.96483 7.26987 9.86531 7.18657 9.78599C7.10328 9.70667 7.00089 9.65025 6.88934 9.62221L5.01067 9.15554C4.91179 9.12189 4.82569 9.05859 4.76409 8.97424C4.70248 8.8899 4.66838 8.78862 4.66641 8.68419C4.66444 8.57976 4.69471 8.47727 4.75309 8.39066C4.81147 8.30406 4.89513 8.23755 4.99267 8.20021L9.69934 6.33354C9.82896 6.30258 9.96442 6.30598 10.0923 6.34339C10.2202 6.38081 10.3362 6.45094 10.4287 6.54687C10.5253 6.64168 10.596 6.75963 10.6342 6.88951C10.6724 7.01939 10.6767 7.15687 10.6467 7.28887ZM8 0.977539C6.41775 0.977539 4.87104 1.44673 3.55544 2.32578C2.23985 3.20483 1.21447 4.45426 0.608967 5.91607C0.00346629 7.37788 -0.15496 8.98641 0.153721 10.5383C0.462403 12.0901 1.22433 13.5156 2.34315 14.6344C3.46197 15.7532 4.88743 16.5151 6.43928 16.8238C7.99113 17.1325 9.59966 16.9741 11.0615 16.3686C12.5233 15.7631 13.7727 14.7377 14.6518 13.4221C15.5308 12.1065 16 10.5598 16 8.97754C15.9977 6.85651 15.1541 4.82301 13.6543 3.32322C12.1545 1.82342 10.121 0.979833 8 0.977539V0.977539ZM8 15.6442C6.68146 15.6442 5.39253 15.2532 4.2962 14.5207C3.19987 13.7881 2.34539 12.7469 1.84081 11.5288C1.33622 10.3106 1.2042 8.97014 1.46144 7.67694C1.71867 6.38373 2.35361 5.19584 3.28596 4.26349C4.21831 3.33114 5.4062 2.69621 6.6994 2.43897C7.99261 2.18174 9.33305 2.31376 10.5512 2.81834C11.7694 3.32293 12.8106 4.17741 13.5431 5.27374C14.2757 6.37007 14.6667 7.659 14.6667 8.97754C14.6647 10.7451 13.9617 12.4396 12.7119 13.6894C11.4621 14.9393 9.76752 15.6423 8 15.6442Z",
              fill: "#0200BC"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_18574" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 0.977539)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { NavigationOutlined };
